import { type ConsentInfoResponse } from '@logto/schemas';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import UserAvatar from '@/assets/icons/default-user-avatar.svg?react';

import { ConsentPresentation } from '../consent-presentation';

import styles from './index.module.scss';

type Props = {
  readonly user: ConsentInfoResponse['user'];
  readonly className?: string;
};

const UserProfile = ({ user, className }: Props) => {
  const { t } = useTranslation();
  const { avatar } = user;
  const { name, identifier } = new ConsentPresentation(user).account;

  return (
    <div className={classNames(styles.wrapper, className)}>
      {avatar ? (
        <img src={avatar} alt="avatar" className={styles.avatar} />
      ) : (
        <UserAvatar className={styles.avatar} />
      )}
      <div>
        <div className={styles.name}>{name ?? t('description.rabbitvis_account')}</div>
        {identifier && <div className={styles.identifier}>{identifier}</div>}
      </div>
    </div>
  );
};

export default UserProfile;
